interface PhotoFrameProps {
  /** Photo réelle ; absente : emplacement neutre qui dit quelle photo mettre. */
  src?: string;
  alt: string;
  /** Légende posée sur la photo (petite étiquette blanche). */
  caption?: string;
  /** Place de la légende sur la photo (en bas par défaut). */
  captionPosition?: "top" | "bottom";
  /** Ce qu'il faut photographier, affiché tant que la photo manque. */
  placeholder?: string;
  className?: string;
  imgClassName?: string;
  /** Photo visible dès l'ouverture de la page : chargée tout de suite. */
  eager?: boolean;
}

/** Photo du site public dans un cadre arrondi, avec légende ; emplacement neutre en attendant une vraie photo. */
export default function PhotoFrame({
  src,
  alt,
  caption,
  captionPosition = "bottom",
  placeholder,
  className = "",
  imgClassName = "",
  eager,
}: PhotoFrameProps) {
  return (
    <figure className={`relative overflow-hidden rounded-[1.75rem] bg-background-200 ${className}`}>
      {src ? (
        <img src={src} alt={alt} loading={eager ? "eager" : "lazy"} decoding="async" className={`h-full w-full object-cover ${imgClassName}`} />
      ) : (
        <div className="flex h-full min-h-[220px] w-full flex-col items-center justify-center gap-2 border-2 border-dashed border-background-300 p-6 text-center text-foreground-500">
          <i className="ri-image-line text-3xl" aria-hidden="true"></i>
          <span className="text-sm">{placeholder ?? "Photo à venir"}</span>
        </div>
      )}
      {caption && src && (
        <figcaption className={`absolute left-4 ${captionPosition === "top" ? "top-4" : "bottom-4"} max-w-[80%] rounded-full bg-white/95 px-4 py-2 text-xs font-medium text-foreground-800 shadow-card`}>
          {caption}
        </figcaption>
      )}
    </figure>
  );
}
